import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '@/components/shared/Logo.tsx';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-card px-4">
      <Logo size="lg" />
      <h1 className="mt-8 text-6xl font-heading text-foreground">
        {t('notFound.title')}
      </h1>
      <p className="mt-3 text-lg text-muted-foreground">
        {t('notFound.message')}
      </p>
      <p className="mt-1 text-sm text-muted-foreground">
        {t('notFound.description')}
      </p>
      <button
        onClick={() => navigate(-1)}
        className="mt-8 rounded-lg bg-primary px-6 py-2.5 text-sm font-semibold text-white hover:bg-primary-hover transition-colors"
      >
        {t('notFound.goBack')}
      </button>
    </div>
  );
}
